export default {
    lang: 'en',
    serverError: 'Server Error, Error Code 500!',
    enterPhoneNumber: 'Enter phone number',
    enterPhoneNumberOrEmail: 'Enter phone number or email',
    phoneNumber: 'Mobile Number',
    enterAccount: 'Enter account',
    noChineseAllowed: 'Please enter a valid phone number or email',
    noSpecialCharsAllowed: 'No special characters allowed',
    onlyDigitsAllowed: 'Only digits allowed',
    yiyouzhanghao: 'Already have an account?',
    xiangqilaile: 'Remembered？Go',
    qudenglu: 'log in',
    login: 'Login',
    yuedutongyi: 'I have read and agree to the',
    yonghufuwuxieyi: 'Terms of Service',
    yinsixieyi: 'Privacy Policy',
    dunhao: ' and ',
    gouxuantongyixieyi: 'Please agree to the Terms of Service and Privacy Policy first',
    zhanghaogeshicuowu: 'The account format is invalid',
    yonghuyizhuce: 'User already registered',
    yonghuweizhuce: 'User not registered',
    qingshuruzhengquedeshoujihao: 'Please enter a valid mobile number',
    pleaseEnterValidPhoneNumber: 'Please enter a valid phone number format',
    jiaoyanyonghucuowu: 'User verification error. Please try again later',
    yixiangninfasong: 'A 4-digit SMS verification code has been sent to your mobile number ',
    qingchashouyanzhengma: '',
    xiugaizhanghao: 'Modify Account',
    fasongyanzhengma: 'Send Verification Code',
    houkechongfaqian: 'Resend available in ',
    houkechongfahou: '',
    haikeyihuoqu: 'You can request verification code',
    ciyanzhengma: 'more times',
    weilezhanghaoanquan: 'For the security of your account, please set a password for account ',
    shezhimimajuhao: '',
    shezhimima: 'Set Password',
    zhengzaiweizhanghao: 'Set a new password for account ',
    shezhixinmima: '',
    qingshurumima: 'Enter the password',
    zhishao: 'At least ',    // 至少多少位数
    zhishaoweishu: ' characters',    // 至少多少位数的位
    zhiduo: 'At most ',
    baohanshuzi: 'Must contain numbers',
    baohanzimu: 'Must contain letters',
    baohandaxiaoxiezimu: 'Must include uppercase and lowercase letters',
    baohanteshuzifu: 'Must include special characters',
    zaicishurumima: 'Enter the password again',
    queding: 'Confirm',
    mimachangdutishi: 'The password should be 10 to 20 characters long, including numbers, uppercase and lowercase letters, and special characters',
    qingzaicishurumima: 'Enter the password again',
    liangcimimabuyizhi: 'The passwords entered twice do not match!',
    chongzhichenggongtiaozhuan: 'Password reset successful, redirecting shortly',
    chongzhichenggong: 'Password reset successful',
    ruhechenghunin: 'How should we address you?',
    qingshuruxingming: 'Please enter your username',
    wancheng: 'Finish',
    zhucechenggong: 'Registration successful',
    xmiaohoudengluqian: 'Automatic login in ',
    enterEmail: 'Enter email',
    pleaseEnterEmail: 'Please enter email address',
    emailFormatError: 'Invalid email format',
    useEmailInstead: 'Use Email',
    usePhoneInstead: 'Use Phone',
    useEmailSignup: 'Register with Email',
    usePhoneSignup: 'Register with Phone',
    useEmailFindpwd: 'Retrieve with Email',
    usePhoneFindpwd: 'Retrieve with Phone',
    hasSentEmailTo: 'An email has been sent to ',
    pleaseCheckEmail: 'Please check your email to complete verification (valid for 1 day).',
    xmiaohoudengluhou: ' seconds',
    mimadenglu: 'Account',
    yanzhengmadenglu: 'SMS Verification',
    fouryanzhengma: '4-digit verification code',
    jizhumima: 'Remember password',
    wangjimima: 'Forgot password',
    qitalogin: 'Other Login Methods',
    wechatdenglu: 'WeChat Login',
    wechatdenglutips: 'Scan QR code with WeChat for secure and convenient login',
    wechatshouquan: 'WeChat Authorization Login',
    wechatdenglufooter: 'By logging in, you agree to the Terms of Service and Privacy Policy',
    yonghushoujibangding: 'User Mobile Binding',
    yonghushoujibangdingyudaokunnan: 'Having trouble with user mobile binding?',
    yonghushoujibangdingchenggong: 'Mobile binding successful!',
    zhuce: 'Sign up',
    shezhinicheng: 'Set Username',
    gaizenmechenghunin: 'How should we address you?',
    denglutixing: 'Login Reminder',
    yizaiqitadifangdenglu: 'Your account has been logged in elsewhere. To ensure the security of your account, this login will log out other sessions. If this was not your action, please change your password as soon as possible and pay attention to account security.',
    quxiao: 'Cancel',
    jixudenglu: 'Continue',
    dengluxietong: '登录协同',
    huoquyanzhengma: 'Get Verification Code',
    qingshuruyanzhengma: 'Enter the verification code',
    yanzhengmaweishuzi: 'Verification code must be numeric',
    yanzhengmageshicuowu: 'Verification code format is incorrect',
    chongxinfasong: 'Resend',
    yanzhengmadashangxian: 'The maximum number of verification code requests has been reached. Please try again after 2 hours',
    shiyongwangjimima: 'Please use the forgot password function to change your password',
    baxianSystemFirstcontent: 'Collaborative Delivery Platform · Making Management Effortless',
    baxianSystemSecondcontent: 'Projects · Tasks · Documents · Communication · Tools',
    maliangSystemFirstcontent: 'Redefine design with data',
    maliangSystemSecondcontent: '',
    dayuSystemFirstcontent: 'Data Intelligence Foundation Platform',
    dayuSystemSecondcontent: 'Making Data Services Smarter',
    jiuzhouSystemFirstcontent: 'Architecture and Urban Space Platform',
    jiuzhouSystemSecondcontent: 'Collection, Integration, and Sharing of Data for Buildings, Campuses, Municipalities, and Cities',
    gong: 'Total:',
    tiao: 'items',
    ye: 'page',
    zhanghaoshangweizhuce: 'This account is not registered',
    zhanghaoyijingcunzai: 'Account already exists',
    shoujihaoweizhuce: 'This phone number is not registered',
    zhanghaogeshibuzhengque: 'The account format is invalid',
    zhanghaobucunzai: 'Account does not exist, please check your input',
    shoujihaoyizhuce: 'This phone number is already registered',
    yanzhengmacuowu: 'Verification code error, please re-enter',
    yangzhengmashixiao: 'Verification code has expired, please request a new one',
    yanzhengmabucunzai: 'The verification code does not exist. Please request a new verification code',
    zhanghaomimacuowu: 'Incorrect account or password',
    xinjiumimayizhi: 'New password is the same as the old password',
    tuxingyanzhengmacuowu: 'Incorrect CAPTCHA, please re-enter',
    dengluchushihua: 'The account has no password set or the password was reset due to a system upgrade. Please use a verification code to log in and initialize',
    dengluguoqi: 'Login expired, redirecting to login shortly!',
    qingqiulujingcuowu: 'Request path error or requested resource does not exist!',
    fuwuqifashengcuowu: 'Server error',
    qingqiuyichang: 'Request exception',
    wanshanxinxi: 'Complete Information',
    shuruzhanghao: 'Enter account',
    anquanyanzheng: 'Security Verification',
    zhaohuimimayudaokunnan: 'If you encounter difficulties in retrieving your password',
    sendEmail: 'you can send an email to',
    forHelp: 'for assistance',
    chongzhimima: 'Reset Password',
    nextStep: 'Next',
    shuruyonghuming: 'Please enter your username',
    remen: 'Popular',
    code86: 'Chinese Mainland',
    code852: 'Hong Kong, China',
    code853: 'Macao, China',
    code65: 'Singapore',
    code60: 'Malaysia',
    shenqingshiyong: 'Tria',
    jinzhishangchuan: "Reminder: Uploading confidential documents (including work secrets) is prohibited!"
}